module.exports = __webpack_public_path__ + "static/Simpsons-2dffc11cf36aab5697bfcc3ba9514c2e.jpg";